/**
 * Snippets API
 * Here is the API DNA
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Constant } from './constant';
import { VariableSerializerLean } from './variableSerializerLean';

export interface RuleSerializerNested {
  readonly id?: number;
  varLeft: VariableSerializerLean;
  operator: RuleSerializerNested.OperatorEnum;
  varRight?: VariableSerializerLean;
  constant?: Constant;
  exactMatch?: boolean;
}
export namespace RuleSerializerNested {
  export type OperatorEnum = 'GT' | 'LT' | 'EQ' | 'NE' | 'SIM' | 'GTE' | 'LTE' | 'IN' | 'NIN' | 'EXI' | 'NULL' | 'CONT';
  export const OperatorEnum = {
    GT: 'GT' as OperatorEnum,
    LT: 'LT' as OperatorEnum,
    EQ: 'EQ' as OperatorEnum,
    NE: 'NE' as OperatorEnum,
    SIM: 'SIM' as OperatorEnum,
    GTE: 'GTE' as OperatorEnum,
    LTE: 'LTE' as OperatorEnum,
    IN: 'IN' as OperatorEnum,
    NIN: 'NIN' as OperatorEnum,
    EXI: 'EXI' as OperatorEnum,
    NULL: 'NULL' as OperatorEnum,
    CONT: 'CONT' as OperatorEnum,
  };
}
